module.exports = __webpack_public_path__ + "static/birds-57ef77c241fa856355f398e5c0bf49a5.png";